import axios from 'axios';
import { store }from '../store'; // make sure the path to the store is correct

const dynamic_axios = axios.create();

dynamic_axios.interceptors.request.use(
  async config => {
    const access_token = store.getters.authToken
    // If apiName is provided, get the configuration from Vuex
    const apiConfig = config.apiName ? store.getters.getAPIConfig(config.apiName) : store.getters.perferedAPI;
    if (apiConfig) {
      config.baseURL = apiConfig.baseURL;
      config.headers = {
        ...config.headers, // Keep existing headers
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${access_token}`,
        'Accept': 'application/json',
        'Content-Type': config.headers['Content-Type'] || 'application/x-www-form-urlencoded',
        'Company': apiConfig.headers?.Company // Use company from Vuex config
      };
    } else {
      // Use default headers if no apiName or specific API config
      const company = config.headers.Company || store.getters.company;
      config.headers = {
        ...config.headers, // Keep existing headers
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${access_token}`,
        'Accept': 'application/json',
        'Content-Type': config.headers['Content-Type'] || 'application/x-www-form-urlencoded',
        'Company': company // Use company from Vuex config
      };
    }
    if (apiConfig) {
      config.baseURL = apiConfig.baseURL;
    }

    return config;
  },
  error => Promise.reject(error)
);

dynamic_axios.interceptors.response.use(response => {
  return response;
}, async function (error) {
  // Check if error.response exists before accessing status
  if (!error.response) {
    // Handle errors without a response (e.g., network errors)
    console.error("Network Error or no response received:", error);
    return Promise.reject(error);
  }
  const originalRequest = error.config;
  if (error.response.status === 401) {
    originalRequest._retry = true;
    store.dispatch("signUserOut");
    window.location.href = "/";
    return Promise.reject(false);
  }
  if (error.response.status === 403 && !originalRequest._retry) {
    const old_token = store.getters.authToken;
    await store.dispatch("refreshToken");
    const new_access_token = store.getters.authToken;
    originalRequest._retry = (old_token !== new_access_token);
    return dynamic_axios(originalRequest);
  }
  return Promise.reject(error);
});

export default dynamic_axios;
